import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { withBuScope } from '@/lib/business-unit-scope';
import type { ApiResponse, TicketPreprocessingConfig } from '@/types';

/** Per brand; a brand that has saved nothing reads the account's config. */
export const ticketPreprocessingService = {
	async getTicketPreprocessingConfig(scope?: { bu_id?: string }): Promise<TicketPreprocessingConfig> {
		const res = await api.get<ApiResponse<{ config: TicketPreprocessingConfig }>>(
			API_ENDPOINTS.BRAND.TICKET_PREPROCESSING,
			{ params: scope }
		);
		return res.data.data.config;
	},

	async updateTicketPreprocessingConfig(
		payload: TicketPreprocessingConfig,
		scope?: { bu_id?: string }
	): Promise<TicketPreprocessingConfig> {
		const res = await api.put<ApiResponse<{ config: TicketPreprocessingConfig }>>(
			withBuScope(API_ENDPOINTS.BRAND.TICKET_PREPROCESSING, scope ?? {}),
			payload
		);
		return res.data.data.config;
	}
};
